module.exports = __webpack_public_path__ + "img/4ed862f.png";